
import { defineComponent, computed, ref, onMounted } from "vue";
import ApiService from "@/core/services/ApiService";
import { MenuComponent } from "@/assets/ts/components";
import { useRoute } from "vue-router";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import { DrawerComponent } from "@/assets/ts/components/_DrawerComponent";
import SupportMessageDrawer from "@/layout/extras/SupportMessageDrawer.vue";

export default defineComponent({
  name: "merchants-tickets",
  components: { Datatable, SupportMessageDrawer },
  setup() {
    const openDrawer = () => {
      DrawerComponent?.getInstance("kt_support_drawer_chat")?.toggle();
    };
    const referralDetails = ref([]);
    const searchParam = ref({
      search: "",
      id: "",
      title: "",
      status: "",
      created: "",
      category: "",
      expires_at: "",
    });
    onMounted(async () => {
      setTimeout(async () => {
        let res;
        try {
          res = await ApiService.get(
            `merchants/support_tickets?merchant_id=${getMerchantId.value}`
          );
          tickets.value = res.data.data;
          tableData.value = await getTickets(pagination.value, sort.value);
          loading.value = false;
        } catch {
          tickets.value = [];
        }
        referralPayouts();
        reInitializeMenus();
      }, 1000);
    });
    const referralPayouts = async () => {
      try {
        const { data } = await ApiService.get(`users/payouts`);
        if (data.success) {
          referralDetails.value = data.data;
        } else {
          referralDetails.value = [];
        }
      } catch (e) {
        referralDetails.value = [];
      }
    };
    const search = async () => {
      loading.value = true;
      tableData.value = await getTickets(pagination.value, sort.value);
      loading.value = false;
    };
    const getTickets = async (pagination, sort) => {
      try {
        const { page, rowsPerPage } = pagination;
        const offset = (page - 1) * rowsPerPage;

        let sortParam = "";
        const { columnName, order } = sort;
        if (columnName !== "") {
          sortParam = `&sort=${columnName},${order}`;
        }

        let url = `merchants/support_tickets?merchant_id=${getMerchantId.value}&offset=${offset}&limit=${rowsPerPage}${sortParam}`;

        if (searchParam.value.search !== "") {
          url = `${url}&search[]=${searchParam.value.search}`;
        }
        if (searchParam.value.id !== "") {
          url = `${url}&id=${searchParam.value.id}`;
        }
        if (searchParam.value.title !== "") {
          url = `${url}&title=${searchParam.value.title}`;
        }
        if (searchParam.value.status !== "") {
          url = `${url}&status=${searchParam.value.status}`;
        }
        if (searchParam.value.created !== "") {
          url = `${url}&created=${searchParam.value.created}`;
        }
        if (searchParam.value.category !== "") {
          url = `${url}&category=${searchParam.value.category}`;
        }
        const { data } = await ApiService.get(url);
        return data;
      } catch (err) {
        return {
          data: [],
          meta: {
            total: 0,
          },
        };
      }
    };
    const tableHeader = ref([
      {
        key: "checkbox",
        sortable: false,
      },
      {
        name: "Title",
        key: "title",
        sortable: true,
      },
      {
        name: "Status",
        key: "status",
        sortable: true,
      },
      {
        name: "Created",
        key: "created",
        sortable: true,
      },
      {
        name: "Category",
        key: "category",
        sortable: true,
      },
      {
        name: "Due By",
        key: "expires_at",
        sortable: true,
      },
      {
        name: "Details",
        key: "actions",
      },
    ]);
    const checkedTickets = ref([]);

    const tableData = ref({
      data: [],
      meta: {
        total: 0,
      },
    });
    const loading = ref(true);
    const pagination = ref({
      page: 1,
      rowsPerPage: 5,
    });
    const sort = ref({
      columnName: "",
      order: "",
    });
    const reInitializeMenus = () => {
      setTimeout(() => {
        MenuComponent.reinitialization();
      }, 0);
    };

    const route = useRoute();
    const getMerchantId = computed(() => {
      return route.params.id;
    });
    const tickets = ref([]);
    const onCurrentChange = async (val) => {
      pagination.value.page = val;

      loading.value = true;
      tableData.value = await getTickets(pagination.value, sort.value);
      loading.value = false;
    };

    const onSort = async (val) => {
      sort.value = val;

      loading.value = true;
      tableData.value = await getTickets(pagination.value, sort.value);
      loading.value = false;
    };

    const onItemsPerPageChange = async (val) => {
      pagination.value.rowsPerPage = val;

      loading.value = true;
      tableData.value = await getTickets(pagination.value, sort.value);
      loading.value = false;
    };

    return {
      tickets,
      searchParam,
      tableData,
      tableHeader,
      loading,
      pagination,
      getMerchantId,
      checkedTickets,
      onCurrentChange,
      onSort,
      onItemsPerPageChange,
      search,
      referralDetails,
      openDrawer,
    };
  },
});
